export default __webpack_public_path__ + "static/media/a9c112b702a1449d7229541474ae1d7b.0c5f98f0.svg";